import SignOutRedirect from '@/pages/auth/components/SignOutRedirect';

export default function SignOut() {
	return (
		<>
			<SignOutRedirect />
		</>
	);
}
